import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown} from '@fortawesome/free-solid-svg-icons';
import SmallHeading from './../components/SmallHeading';
import Heading from './../components/Heading';
import DetailsHeading from './../components/DetailsHeading';

const gfaqs = [
    { id: 1, question: "What is PocketLPO?", answer: "PocketLPO is a legal process outsourcing provider offering remote in-house counsel services. We specialize in delivering cost-effective, scalable, and expert legal support tailored to businesses of all sizes." },
    { 
        id: 2, 
        question: "What services do you offer?", 
        answer: `We offer a wide range of non-litigation legal services, including:
        • Corporate Governance & Compliance
        • Contract Management & Review
        • Intellectual Property Management
        • HR Legal Support
        • Data Privacy & Protection
        • M&A and Corporate Transaction Support

        Note: For a detailed list, please visit our Services Page.`
      },      
    { id: 3, question: "How is PocketLPO different from a traditional law firm?", answer: "PocketLPO operates as a strategic legal partner rather than a traditional law firm. We do not engage in litigation or provide legal representation. Instead, we specialize in supporting businesses with preventive law strategies, legal process management, and transactional assistance. Our model is designed to offer remote, flexible, and cost-effective solutions to meet your operational needs." },
];
const sfaqs = [
    { id: 4, question: "How does remote in-house counsel work?", answer: "We act as an extension of your team. Through our platform, you gain access to experienced legal professionals who handle your business’s legal needs remotely. Communication is seamless via email, video conferencing, and collaborative tools." },
    { id: 5, question: "Can I customize the services I need?", answer: "Absolutely! Our pricing models and service packages are designed to be flexible. Whether you need a fixed fee for a specific task or ongoing support through subscription plans, we tailor our offerings to fit your requirements." },
    { id: 6, question: "Do you offer support for global compliance regulations?", answer: "Yes, we provide comprehensive services for global data protection regulations such as GDPR, CCPA, and HIPAA. We also assist with compliance audits and breach response planning." },
];
const pfaqs = [
    { 
        id: 7, 
        question: "What pricing models do you offer?", 
        answer: `We offer a variety of pricing options to suit different needs:
        • Subscription Plans: Monthly, quarterly, and annual plans with allocated hours.
        • Fixed Fee Services: Transparent pricing for specific legal tasks.
        • Full-Time Employee (FTE) Services: Dedicated legal professionals assigned to your business. Visit our Pricing Page for detailed information.`       
    },      
    { id: 8, question: "What happens if I need more hours than my plan includes?", answer: "No problem! Additional hours can be purchased at a discounted rate. Rollover options may also be available depending on your plan." },
    { id: 9, question: "Do you provide free consultations?", answer: "Yes, we offer an initial consultation to understand your needs and recommend the best service options. Contact us to schedule your free session." },
];
const tfaqs = [
    { id: 10, question: "How do you ensure data security?", answer: "We prioritize client confidentiality and data protection. Our systems are compliant with industry standards. We use secure platforms for communication and document management"},      
    { id: 11, question: "Do you use AI tools in your services?", answer: "Yes, we leverage AI-driven tools for contract lifecycle management, document automation, and e-discovery to enhance efficiency and accuracy." },
];
const gsfaqs = [
    { id: 12, question: "How do I sign up for your services?", 
        answer: `You can get started by:
        1.	Choosing a plan on our Pricing Page.
        2.	Contacting us through our Contact Form.
        3.	Scheduling a free consultation to discuss your needs.
    `},      
    { id: 13, question: "What is the onboarding process? ", 
        answer: `Once you sign up, we:
        1.	Assign a dedicated legal expert to your account.
        2.	Conduct an initial meeting to understand your requirements.
        3.	Begin delivering services according to the agreed plan.
    `},
];


const FAQ = () => {
    const [openId, setOpenId] = useState(null);

    const toggleFAQ = (id) => {
        setOpenId(prevId => (prevId === id ? null : id));
    };

    return (
        <section className="py-10">
            <SmallHeading name="FAQs" tstyle="text-center my-1 pt-10"/>
            <Heading name="Frequently Asked Questions" tstyle="text-center my-1"/>
            <div className='mt-4 px-10' >
                <DetailsHeading 
                 name="Welcome to the PocketLPO FAQ page! Here, we answer common questions about our services, pricing, and how we can support your business's legal needs." 
                 tstyle="my-1"
                />
            </div>
            <div className="grid grid-cols-1 items-center">
                <div className='mx-10 md:mx-20'>
                    <div className="grid grid-cols-1 gap-4 mt-10 ">
                    <SmallHeading name="General Questions" tstyle="text-center font-bold"/>
                        {gfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 gap-4 mt-4">
                    <SmallHeading name="Service Delivery" tstyle="text-center font-bold"/>
                        {sfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 gap-4 mt-4">
                    <SmallHeading name="Pricing and Plans" tstyle="text-center font-bold"/>
                        {pfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 gap-4 mt-4">
                    <SmallHeading name="Technology & Security" tstyle="text-center font-bold"/>
                        {tfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className="grid grid-cols-1 gap-4 mt-4">
                    <SmallHeading name="Getting Started" tstyle="text-center font-bold"/>
                        {gsfaqs.map((faq) => (
                            <div key={faq.id} className="border rounded-lg overflow-hidden shadow-md">
                                <button
                                    className={`flex justify-between items-center w-full p-4
                                    ${openId === faq.id ? ' text-white bg-emerald-600 opacity-80' : 'bg-emerald-50'}`}

                                    onClick={() => toggleFAQ(faq.id)}
                                >
                                    <span className="text-lg font-medium">{faq.question}</span>
                                    <FontAwesomeIcon 
                                        className={`w-5 h-5 text-xl transition-transform duration-300
                                            ${openId === faq.id ? '-rotate-180' : 'rotate-0'}`} 
                                        icon={faChevronDown} 
                                    />
                                </button>
                                {openId === faq.id && (
                                    <div className="whitespace-pre-line p-4 bg-white border-t">
                                        {faq.answer}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>

                    <div className='mt-10 text-center'>    
                    <Heading name="Still Have Questions?" tstyle="text-center my-1"/>
                    <p>If you can’t find the answer here, feel free to contact us at <a href="/" className='text-emerald-600 underline'>legal@pocketlpo.com</a></p>   
                    </div>
                </div>
            </div>

        </section>        
    );
};

export default FAQ;
